exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".page-switch{padding:0 15px 15px}.page-switch__wrapper{width:33.33%;float:left;text-align:center}.page-switch__text{margin:20px 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-d7f13822!./~/vue-loader/lib/selector.js?type=styles&index=0!./docs/examples/switch.vue
// module id = 240
// module chunks = 0